import { User } from '@/shared/api';

import { IUser } from '../types';

export const serializeUser = (user: User | null): IUser | null =>
  user
    ? {
        id: user.userId,
        email: user.personal.email ?? '',
        phone: user.personal.phone ?? '',
        isRegistered: Boolean(user.personal.phone),
        firstName: user.personal.name?.firstName ?? '',
        middleName: user.personal.name?.middleName ?? '',
        lastName: user.personal.name?.lastName ?? '',
        residenceCountry: user.personal.residenceCountry?.item?.name || '',
        birthDate: user.personal.birthDate,
        isHasAddress: Boolean(user.addresses?.count),
        address: user.addresses?.nodes?.length
          ? user.addresses?.nodes[0]
          : undefined,
      }
    : null;
